import { ApiProperty } from "@nestjs/swagger";
import { IsOptional, MaxLength, Matches } from "class-validator";

export class RouteDto {
    @ApiProperty()
    routeId: number;

    @ApiProperty()
    routeNumber:string;

    @ApiProperty()
    vehicleNumber:string;

    @ApiProperty()
    distance:string;

    @ApiProperty()
    plant:string;

    @ApiProperty()
    pickUp:string[];

    @ApiProperty()
    isActive: boolean;
  
    createdAt : Date;
  
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;
  
    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;
  
    @ApiProperty()
    versionFlag : number;
}